module.exports = __webpack_public_path__ + "static/img/decor3.f67b6d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/diwali/decor3.svg
// module id = W42i
// module chunks = 0